<template>
  <div class="container">
    <slot />
  </div>
</template>

<script lang="ts">
import { Component, Mixins, Watch } from 'vue-property-decorator';

import AppConfigMixin from '@/mixins/appConfigMixin';

@Component
export default class RatingView extends Mixins(AppConfigMixin) {
  async created() {
    document.title = this.$t('metaTitle').toString();
    await this.setBasicData();
    await this.setDefaultFacility(this.redirectToRating);
    await this.sendAnalytics();
  }

  private redirectToRating() {
    this.$router.push({
      name: 'rating',
      params: { slug: this.$route.params.slug },
    });
  }

  @Watch('$route.query.edit', { immediate: true })
  private setDefaultOnRouteChange(current: string, previous: string) {
    if (previous) {
      this.setDefaultFacility(this.redirectToRating);
    }
  }
}
</script>
